// var scene = document.getElementById('scene');
// new Parallax(scene);

$('.feedbackSlider').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    variableWidth: true,
    dots: false,
    speed: 500,
    prevArrow: $('.prevFeedback'),
    nextArrow: $('.nextFeedback'),
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                dots: true
            }
        }
    ]
});


// Our Product Custom Slider

function  changeProductSlide(newSlideNumber) {

    //change active nav button
    $('.ourProductNavList').attr('active-slide' , newSlideNumber);

    // change slide
    $('.ourProductItem').removeClass('activeOurProductSlide');
    $('.ourProductBody').removeClass('fadeIn');
    // $('.ourProductImage').removeClass('fadeIn');
    $('.ourProductItem[product-slide-number="'+ newSlideNumber +'"]').addClass('activeOurProductSlide');
    $('.ourProductItem[product-slide-number="'+ newSlideNumber +'"] .ourProductBody').addClass('fadeIn');
    // $('.ourProductItem[product-slide-number="'+ newSlideNumber +'"] .ourProductImage').addClass('fadeIn');

}


if ( $(window).width() <= 480 ) {

    $('.ourProductItem').on( 'click' , function () {

        $(this).addClass('ourProductItemOpen');

        $('html, body').animate({
            scrollTop: $(this).offset().top
        }, 200);

    });

} else {

    $('.ourProductNextSlide').on( 'click' , function () {

        var nextSlidNumber = $(this).attr('next-product-number');

        changeProductSlide(nextSlidNumber);


    });

    $('.ourProductNavList li').on( 'click' , function () {

        var slidNumber = $(this).attr('product-slide-number');

        changeProductSlide(slidNumber);

    });

}

